export default "__VITE_ASSET__CxSGNv5$__"